<template>
  <b-modal id="bv-search-message" size="xl" hide-footer>
    <template #modal-title> Search message </template>
    <div class="search-container">
      <b-input-group
        size="sm"
        style="
          position: relative;
          width: 50%;
          padding: 10px 10px 10px 0px;
          float: right;
        "
      >
        <b-form-input
          size="sm"
          v-on:keyup.enter="getMessage"
          v-model="filterInput"
          autocomplete="off"
          type="search"
          id="filterInput"
          placeholder="Type SHP code or subject for search"
        >
        </b-form-input>
        <b-input-group-append>
          <b-button
            aria-label="Click here to clean the search input"
            class="message-table__buttons"
            :disabled="!filterInput"
            @click="getMessage()"
            ><b-icon icon="search"></b-icon
          ></b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <b-overlay :show="activeSpinner" rounded opacity="0.8" spinner-small>
      <b-table
        class="message-table"
        id="messageTable"
        show-empty
        stacked="md"
        medium
        responsive="sm"
        head-variant="light"
        :items="items"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <thead class="message-table__head">
          <tr>
            <th class="message-table__th">QUOTE ID</th>
            <th class="message-table__th">MESSAGE ID</th>
            <th class="message-table__th">SUBJECT</th>
            <th class="message-table__th">ASSIGNED</th>
            <th class="message-table__th">STATUS</th>
            <th class="message-table__th">URL</th>
            <th class="message-table__th">QUEUE</th>
          </tr>
        </thead>
        <tbody>
          <section
            v-if="items.length === 0"
            style="padding: 15px; width: max-content"
          >
            <td>No data found to display.</td>
          </section>
          <tr
            class="message-table__tr"
            v-for="(message, index) in items"
            :key="index"
          >
            <td class="message-table__td" v-html="message.quote_id"></td>
            <td class="message-table__td" v-html="message.message_id"></td>
            <td class="message-table__td" v-html="message.subject"></td>
            <td class="message-table__td" v-html="message.user_assigned"></td>
            <td class="message-table__td" v-html="message.status"></td>
            <td class="message-table__td" v-html="message.url"></td>
            <td class="message-table__td" v-html="message.queue"></td>
          </tr>
        </tbody>
      </b-table>
    </b-overlay>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="messageTable"
      align="center"
      small
    ></b-pagination>
  </b-modal>
</template>

<script>
export default {
  name: "Search-Form",
  props: {
    fileInfo: Object
  },
  components: {},
  data() {
    return {
      info: [],
      items: [],
      filterInput: null,
      currentPage: 1,
      perPage: 10,
      activeSpinner: false
    };
  },
  watch: {
    filterInput: async function() {
      if (this.filterInput == "") {
        await this.reloadTable();
      }
    }
  },
  computed: {
    rows() {
      return this.items.length;
    }
  },
  async created() {},
  methods: {
    async getMessage() {
      this.activeSpinner = true;
      const payload = {};
      if (this.filterInput.includes("SHP")) {
        payload.shp = this.filterInput;
      } else {
        payload.subject = this.filterInput;
      }
      let response = await this.$store.dispatch(
        "usersManagement/getMessage",
        payload
      );
      this.activeSpinner = false;
      this.items = response?.data;
    },
    async reloadTable(index) {
      this.items.splice(index);
    }
  }
};
</script>
<style lang="scss" scoped>
.search-container {
  background-color: #283747;
  width: 100%;
  height: 50px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.09), 0 1px 5px rgba(0, 0, 0, 0.09);
}
.message-table {
  border-spacing: 0;
  border: 1px none #ccc;
  border-radius: 10px;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.09), 0 1px 5px rgba(0, 0, 0, 0.09);
  width: 100%;
  background-color: white;
  &__buttons {
    @include primary-button;
  }
}
::v-deep .table > thead {
  vertical-align: bottom;
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
}
::v-deep .table > :not(:first-child) {
  border-top: 2px solid currentColor;
  text-align: center;
}
::v-deep .table > tbody {
  vertical-align: inherit;
  border-style: hidden;
}
::v-deep .table .thead-light th {
  border-radius: 0;
}
</style>
